import Vue from "vue"
import VueAnalytics from "vue-analytics"
import App from "./App.vue"

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALYTICS_ID || "UA-91518212-2",
  debug: {
    enabled: process.env.NODE_ENV === "development" ? true : false,
    trace: process.env.NODE_ENV === "development" ? true : false,
    sendHitTask: process.env.NODE_ENV === "development" ? false : true
  }
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount("#app")
